function showSearch() {
    $('#pageSearch__toggle').addClass('isActive');
    $('#pageSearch__target').addClass('isActive');
    $('#pageSearch__overlay').fadeIn();
}

function hideSearch() {
    $('#pageSearch__toggle').removeClass('isActive');
    $('#pageSearch__target').removeClass('isActive');
    $('#pageSearch__overlay').fadeOut();
}

function createSearchOverlay() {
    let $elm = $('<div>');
    $elm
        .addClass('pageSearch__overlay')
        .attr('id', 'pageSearch__overlay');

    $('body').append($elm);
}

$(function () {
    createSearchOverlay();

    $('#pageSearch__toggle').on('click', function () {
        if ($('#pageSearch__target').hasClass('isActive')) {
            hideSearch();
        } else {
            showSearch();
            hideShare();
            profileNav.close();
        }
    });

    $('#pageSearch__overlay').on('click', function () {
        hideSearch();
    })
});
